import moment from 'moment';

const localeDict = {
    'en-GB': 'English',
    //'cs-CZ': 'Čeština',
    'de': 'Deutsch',
};

const rtlLocateDict = [];

export function formatLocale(locale) {
    return localeDict[locale] || 'English';
}

export function isRTL(locale) {
    return locale && rtlLocateDict.indexOf(locale) >=0;
}

export function generateMomentLocaleSettings(locale) {
    var localeData = moment.localeData('en');
    let response = { 
        ordinal: localeData.ordinal()
    };
    return response;
}


// WEBPACK FOOTER //
// src/helpers/formatLocale.js